import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'app-versao-minima',
    templateUrl: './versao-minima-dialog.html',
    styleUrls: ['./versao-minima-dialog.scss', '../../../styles/estilo.padrao.scss']
})
export class AlertaVersaoComponentDialog {
    uid;

    constructor(
        private dialogRef: MatDialogRef<AlertaVersaoComponentDialog>,
    ) {
        this.uid = localStorage.getItem('uid')
    }

    forcarAtualizacao() {
        window.location.reload(true);
    }

}
